import { cn } from "@/shared/lib/utils";
import { initialsOf } from "./format";
import { AGENT_STATUS, TONE_CLASSES, type AgentStatus } from "./status";

const sizes = {
  xs: "h-6 w-6 text-[0.625rem]",
  sm: "h-8 w-8 text-caption",
  md: "h-9 w-9 text-body-sm",
  lg: "h-12 w-12 text-body",
} as const;

const dotSizes = { xs: "h-2 w-2", sm: "h-2.5 w-2.5", md: "h-2.5 w-2.5", lg: "h-3 w-3" } as const;

/** Avatar com iniciais (ou imagem) e ponto de status opcional. */
export function Avatar({
  name,
  src,
  size = "sm",
  status,
  className,
}: {
  name: string | null | undefined;
  src?: string;
  size?: keyof typeof sizes;
  status?: AgentStatus;
  className?: string;
}) {
  return (
    <span className={cn("relative inline-flex shrink-0", className)}>
      {src ? (
        <img src={src} alt="" className={cn("rounded-full object-cover", sizes[size])} />
      ) : (
        <span
          className={cn("inline-flex select-none items-center justify-center rounded-full bg-brand-subtle font-semibold text-brand-accent", sizes[size])}
          aria-hidden
        >
          {initialsOf(name)}
        </span>
      )}
      {status ? (
        <span
          className={cn("absolute -bottom-0.5 -right-0.5 rounded-full ring-2 ring-surface", dotSizes[size], TONE_CLASSES[AGENT_STATUS[status].tone].dot)}
          title={AGENT_STATUS[status].label}
        >
          <span className="sr-only">{AGENT_STATUS[status].label}</span>
        </span>
      ) : null}
    </span>
  );
}
